import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: { main: "#0b679e", dark: "#084d7a", light: "#e7f5fc", contrastText: "#ffffff" },
    secondary: { main: "#26a7e0", contrastText: "#ffffff" },
    success: { main: "#178a68" },
    warning: { main: "#d58a16" },
    error: { main: "#c94343" },
    background: { default: "#f3f7fa", paper: "#ffffff" },
    text: { primary: "#12324a", secondary: "#607589" },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Inter", "Segoe UI", Roboto, Arial, sans-serif',
    h1: { fontWeight: 750, letterSpacing: "-0.03em" },
    h2: { fontWeight: 750, letterSpacing: "-0.025em" },
    h3: { fontWeight: 700 },
    button: { fontWeight: 700, letterSpacing: "0.02em", textTransform: "none" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: 9, minHeight: 38, boxShadow: "none", paddingInline: 16 },
        contained: { boxShadow: "0 4px 10px rgba(11, 103, 158, 0.18)", "&:hover": { boxShadow: "0 6px 14px rgba(11, 103, 158, 0.24)" } },
      },
    },
    MuiOutlinedInput: { styleOverrides: { root: { backgroundColor: "#fff", borderRadius: 9, "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#76bddd" }, "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#0b679e", borderWidth: 2 } }, notchedOutline: { borderColor: "#d6e1e8" } } },
    MuiInputLabel: { styleOverrides: { root: { color: "#607589", "&.Mui-focused": { color: "#0b679e" } } } },
    MuiTableCell: { styleOverrides: { head: { backgroundColor: "#eef6fa", color: "#164762", fontWeight: 750, borderBottom: "1px solid #d8e7ef" }, root: { borderBottom: "1px solid #e6eef2" } } },
    MuiTableRow: { styleOverrides: { root: { "&:hover": { backgroundColor: "#f7fbfd" } } } },
    MuiPaper: { styleOverrides: { root: { borderRadius: 12 } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 14, boxShadow: "0 18px 48px rgba(8, 47, 82, 0.22)" } } },
    MuiAlert: { styleOverrides: { root: { borderRadius: 10 } } },
  },
});

export default theme;
